'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

var _iconsPropType = require('../../iconsPropType');

var _styleMixins = require('../../styles/styleMixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = _extends({}, _iconsPropType.iconsPropType);

var defaultProps = {
  border: false,
  borderWidth: 0,
  rounded: false,
  size: 'normal',
  colorScheme: 'default',
  color: '',
  backgroundColor: '',
  flip: 'none',
  rotate: 0
};

var colorProps = function colorProps(_ref) {
  var themeFromProvider = _ref.theme,
      customColor = _ref.customColor,
      colorScheme = _ref.colorScheme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var iconTheme = theme.reactackle.components.icon;
  var colorSource = customColor || iconTheme.color[colorScheme];

  return '\n    svg,\n    svg * {\n      fill: ' + colorSource + ';\n    }\n  ';
};

var IconSvgStyled = _styledComponents2.default.div.withConfig({
  displayName: 'IconSvgStyled'
})(['box-sizing:border-box;position:relative;', ';svg{position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);fill:currentColor;}', ';', ';', ';', ';', ';', '  '], (0, _reactackleCore.transition)('background-color, color, opacity'), _styleMixins.sizeProps, _styleMixins.backgroundProps, colorProps, _styleMixins.border, _styleMixins.borderRadius, _styleMixins.transform);

IconSvgStyled.propTypes = propTypes;
IconSvgStyled.defaultProps = defaultProps;
IconSvgStyled.displayName = 'IconStyled';

exports.default = IconSvgStyled;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/IconSvg/styles/IconSvgStyled.js
// module id = 722
// module chunks = 0